'use strict'
import { request } from '../../plugins/http'

export default async () => {
    return await request.get('/questionarioClassificacao')
}